if (!customElements.get("progress-bar")) {
	customElements.define(
		"progress-bar",
		class ProgressBar extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.steps = this.querySelectorAll(".progress-bar__step");
				this.target = +this.dataset.target;

				if (this.steps) {
					this.handleStepsPlacement(this.steps);
				}
			}

			handleStepsPlacement(elements) {
				elements.forEach((element) => {
					const currTarget = +element.dataset.target;
					const left = (currTarget * 100) / this.target;
					element.style.left = `${left}%`;
				});
			}
		}
	);
}
